import React from "react";
import Header from "../Header/Header";
import hero_image from "../../assets/hero_image.png";
import hero_image_back from "../../assets/hero_image_back.png";
import heart from "../../assets/heart.png";
import calories from "../../assets/calories.png";
import "./Hero.css";
import { motion } from "framer-motion";
import NumberCounter from "number-counter"


function Hero() {
    const transition ={type:'spring',duration :3}
    const  mobile =window.innerWidth<=768 ? true:false;
    return (
    <div className="hero" id="Home">
        <div className="blur hero-blur"></div>
        <div className="left-h">
        <Header/>
        {/* the best ad */}
        <div className="the-best-ad">
                <motion.div
                initial={{left:mobile ? '165px':'238px'}}
                whileInView={{left:'8px'}}
                transition={{...transition,type:'tween'}}
                ></motion.div>
                <span>the best fitness in the town</span>
        </div>
        {/* the Hero text */}
        <div className="hero-text">
            <div >
                <span className="stroke-text">shape </span>
                <span>your</span>
                </div>


                <div>
                <span>idea body</span>
                </div>
                <div><span>in hero  we will help you to to shape and build
                     your ideal body and live up your life to fullest</span>
                     </div>
        </div>
        {/* figurer */}
        <div className="figurer">
            <div>
            <span><NumberCounter end={140} start={100} delay="4" preFix="+"/></span>
            <span>expert coaches</span>
            </div>
            <div>
            <span><NumberCounter end={978} start={800} delay="4" preFix="+"/></span>
            <span>members joined</span>
            </div>
            <div>
            <span><NumberCounter end={50} start={10} delay="2" preFix="+"/></span>
            <span>fitness programs</span>
            </div>
        </div>

        {/* hero buttons */}
        <div className="hero-buttons">
            <button className="btn">Get Started</button>
            <button className="btn">Learn More</button>
        </div>

        </div>
        <div className="right-h">
            {/* heart rate */}
            <button className="btn">join now</button>
            <motion.div
            initial={{right:'-1rem'}}
            whileInView={{right:'4rem'}}
            transition={transition} 
             className="heart-rate">
                <img src={heart} alt="" />
                <span>heart-rate</span><span>116 bpm</span>
            </motion.div>
            {/* hero images */}

            <img src={hero_image} alt=""className="hero_image" />
            <motion.img
            initial={{right:'15rem'}}
            whileInView={{right:'28rem'}}
            transition={transition}
             src={hero_image_back} alt="" className="hero_image_back" />
        {/* calories */}
        <motion.div
         initial={{right:'37rem'}}
         whileInView={{right:'30rem'}}
         transition={transition} 
         className="calories">
            <img src={calories} alt="" />
            <div>
            <span>calories burned</span>
            <span>220 kcal</span>
            </div>
        </motion.div>
        </div>

    </div>
     );
}

export default Hero;